var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNowyWniosek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 17.1255V21.5005H4.59375L17.0362 8.59717L12.8175 4.22217L0.375 17.1255Z",
    fill: "#273B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2988 3.56783L17.6663 0.837832C17.2275 0.382832 16.5188 0.382832 16.08 0.837832L14.0213 2.97283L18.24 7.34783L20.2988 5.21283C20.7375 4.75783 20.7375 4.02283 20.2988 3.56783Z",
    fill: "#273B4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowyWniosek);
export default __webpack_public_path__ + "static/media/NowyWniosek.b27a5e6746f4717f13f9b8c097827c8e.svg";
export { ForwardRef as ReactComponent };